import { ICoding } from './icoding';

export interface IOutcomeCodeableConcept {
    outcomeCodeableConcept: string;
    codeGuid: string;
    coding: ICoding[];
    text: string;
    tenantId: number;
    language: string;
}